$(document).ready(function(){
$('.testemonial-slider').slick({
  dots: false,
arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
   centerPadding:'0px',
     prevArrow:'<button class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
  nextArrow:'<button class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

   $('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
  dots: true,
   fade: true,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   dots: false,
   vertical: true,
   focusOnSelect: true
 });
  $('.collection-list-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});

 $('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.slider-nav').slick('slickGoTo', slideno - 1);
 });
// contact submit start
  $( ".button-contacts" ).click(function(e){
    e.preventDefault();
  
    var email = $('input#ContactForm-email').val();
   if(email==''){
       $(this).parents('.custom_contact').find('.form__message.custom-error').show();
      
   }
    else{
        $('form#ContactForm').trigger('submit');
    }
    //contact submit end
}); 

  //homepage custom feature product
$('input.custom_color_swatch').click(function(){
var color_val_get = $(this).val().toLowerCase();
$('.product_image_sidebar_items').each(function(){
var product_image_alt = $(this).find('.product_image_sidebars').attr('alt').toLowerCase();
var match_variants_content = product_image_alt.includes(color_val_get);
if(match_variants_content == true){
 
 $(this).trigger("click" );
$(this).addClass('testcode');
}else{
console.log('no');
}

});

})
});
